module.exports = __webpack_public_path__ + "img/Portail pente.2046980b.jpg";